/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Error_No_EventInputs */

const cs_workflow_error_no_event = /** @type {(inputs: Workflow_Error_No_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Událostní spouštěč vyžaduje událost.`)
};

const en_workflow_error_no_event = /** @type {(inputs: Workflow_Error_No_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event trigger requires an event.`)
};

/**
* | output |
* | --- |
* | "Event trigger requires an event." |
*
* @param {Workflow_Error_No_EventInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_error_no_event = /** @type {((inputs?: Workflow_Error_No_EventInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Error_No_EventInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_error_no_event(inputs)
	return cs_workflow_error_no_event(inputs)
});